import { useIDEMode, useIDEModeContext } from './ide/IdeMode';
import { EditMode } from './types';

export function useReadOnlyFlag() {
  const mode = useIDEMode();
  return mode === EditMode.disabled;
}

export function useReadOnlyFlagWithMessage() {
  const { disabledMessage, mode } = useIDEModeContext();
  const isReadOnly = mode === EditMode.disabled;
  return {
    readOnly: isReadOnly,
    disabledMessage: isReadOnly ? disabledMessage || 'Updating is disabled in read only mode' : undefined
  };
}
